import React, { useEffect } from 'react';
import axios from 'axios';
import { serverURL } from '../constants';
import { Spinner } from 'flowbite-react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { buildCourseUrl } from '../utils/slug';

/**
 * /shareable?id=X handler.
 *
 * Most direct visits (new tab, external link) are intercepted by the
 * Express 301 redirect in server.js BEFORE React loads — the user
 * lands on /c/:slug instead. This React component only runs during
 * client-side navigation (e.g. post-login redirect from signin.js).
 *
 * - Authenticated users: fetch course, copy to their account, navigate
 *   to /course with full state (existing behaviour, unchanged).
 * - Non-authenticated users: redirect to /c/:slug preview page via
 *   navigate (replace: true so /shareable doesn't stay in history).
 */
const Shareable = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const id = query.get('id');

        if (!id) {
            toast.error("Course doesn't exist");
            navigate('/');
            return;
        }

        if (sessionStorage.getItem('uid')) {
            loadCourseForUser(id);
        } else {
            redirectToPreview(id);
        }
    }, []);

    async function redirectToPreview(id) {
        try {
            const response = await axios.get(serverURL + `/api/shareable?id=${id}`);
            const course = response.data[0];
            if (!course) {
                toast.error("Course doesn't exist");
                navigate('/');
                return;
            }
            const previewUrl = buildCourseUrl(course.mainTopic, id);
            navigate(previewUrl, { replace: true });
        } catch (error) {
            toast.error("Course doesn't exist");
            navigate('/');
        }
    }

    async function loadCourseForUser(id) {
        try {
            const response = await axios.get(serverURL + `/api/shareable?id=${id}`);
            const course = response.data[0];
            if (!course) {
                toast.error("Course doesn't exist");
                navigate('/');
                return;
            }

            const jsonData = JSON.parse(course.content);
            const type = course.type.toLowerCase();
            const mainTopic = course.mainTopic;
            const user = sessionStorage.getItem('uid');
            const content = JSON.stringify(jsonData);

            const copyResponse = await axios.post(serverURL + '/api/courseshared', { user, content, type, mainTopic });

            if (copyResponse.data.success) {
                sessionStorage.setItem('courseId', copyResponse.data.courseId);
                sessionStorage.setItem('first', copyResponse.data.completed);
                sessionStorage.setItem('jsonData', content);
                navigate('/course', {
                    state: { jsonData, mainTopic: mainTopic.toUpperCase(), type, courseId: copyResponse.data.courseId, end: '', pass: false },
                    replace: true,
                });
            } else {
                sessionStorage.setItem('courseId', id);
                sessionStorage.setItem('shared', id);
                sessionStorage.setItem('jsonData', content);
                navigate('/course', {
                    state: { jsonData, mainTopic: mainTopic.toUpperCase(), type, courseId: id, end: '', pass: false },
                    replace: true,
                });
            }
        } catch (error) {
            toast.error("Course doesn't exist");
            navigate('/');
        }
    }

    return (
        <div className="text-center h-screen w-screen flex items-center justify-center">
            <Spinner size="xl" className='fill-black dark:fill-white' />
        </div>
    );
};

export default Shareable;
